module.exports = __webpack_public_path__ + "static/vimpat-logo-150f0da675039ff29c4fa56926d42110.png";